import React from 'react';
import styled from 'styled-components';

import { ServiceGroup } from '@/types/serviceGroup';

export const SubHeader: React.FC<{
  service: ServiceGroup;
}> = ({ service }) => (
  <div>
    <Header>{service.name}</Header>
  </div>
);

const Header = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 32px;
  color: #292929;
`;
